<template>
  <div v-if="sendToOriginator" class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <InertiaLink class="btn btn-block btn-primary mb-2" :href="route('asset.originator', asset)">
          Send to Counterparty
        </InertiaLink>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from './Mixin';

export default {
  mixins: [Mixin],

  mounted() {
    return false;
  },

  computed: {
    sendToOriginator() {
      this.areAllActionsAccepted();

      if (!this.state.withCounterparty) {
        return false;
      }

      const showForStates = [
        'approved',
      ];

      // Non clausify users won't end up sending the contract
      // to 'pending' > 'approved', so they need to do this from 'editing'
      if (this.userHasType('counter')) {
        showForStates.push('editing');
      }

      if (showForStates.includes(this.state.state)) {
        return this.userHasRole('contract_lead') && !this.allActionsAccepted;
      }

      return false;
    },
  },
};
</script>
